__turbopack_context__.v({
  "collapsibleSection": "MakeModelInterlinking-module__1qojuG__collapsibleSection",
  "collapsibleSectionContent": "MakeModelInterlinking-module__1qojuG__collapsibleSectionContent",
  "container": "MakeModelInterlinking-module__1qojuG__container",
  "ctas": "MakeModelInterlinking-module__1qojuG__ctas",
  "section": "MakeModelInterlinking-module__1qojuG__section",
  "sectionHeading": "MakeModelInterlinking-module__1qojuG__sectionHeading",
  "sections": "MakeModelInterlinking-module__1qojuG__sections",
  "title": "MakeModelInterlinking-module__1qojuG__title",
  "viewMoreButton": "MakeModelInterlinking-module__1qojuG__viewMoreButton",
});
